import { View, XStack, YStack, Text } from "tamagui";
import { CommentWithReplies } from "../../../../../../types/comments";
import { brandShadow } from "../../../../../../../tamagui.config";
import { Pressable } from "react-native";
import { getRelativeTime } from "../utils";
import { CommentReply } from "./CommentReply";

type CommentCardProps = {
  comment: CommentWithReplies;
  onReply: (comment: CommentWithReplies) => void;
};

export const CommentCard = ({ comment, onReply }: CommentCardProps) => {
  return (
    <View
      {...brandShadow}
      bg="white"
      borderWidth={1}
      borderColor="black"
      borderRadius="$4"
    >
      <YStack p="$4">
        <XStack justifyContent="space-between" alignItems="center" mb="$2">
          <Text
            fontFamily="$heading"
            fontSize={16}
            fontWeight="bold"
            textTransform="uppercase"
          >
            {comment.profile?.name}
          </Text>
          <Text fontSize={12} color="$gray10">
            {getRelativeTime(comment.created_at)}
          </Text>
        </XStack>

        <Text fontSize={14} mb="$2">
          {comment.content}
        </Text>

        <Pressable onPress={() => onReply(comment)}>
          <Text
            fontFamily="$heading"
            fontSize={14}
            fontWeight="bold"
            textTransform="uppercase"
          >
            REPLY
          </Text>
        </Pressable>

        {comment.replies?.map((reply) => (
          <CommentReply key={reply.id} reply={reply} />
        ))}
      </YStack>
    </View>
  );
};
